import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminDetailsComponent } from './admin-details/admin-details.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { DatePickerModule } from '../shared/directives/date-picker.module';
import {SharedModule} from '../shared/shared.module';
import { AdminFilterComponent } from './admin-filter/admin-filter.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AdminModalComponent } from './admin-modal/admin-modal.component';
import { AdminProfileComponent } from './admin-profile/admin-profile.component';
import { AdminUniqueEmailDirective } from './admin-unique-email.directive';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    imports: [
        CommonModule, DatePickerModule, SharedModule, FormsModule, UiSwitchModule, ReactiveFormsModule,
        RouterModule, NgbModule,
        AdminDetailsComponent, AdminFilterComponent, AdminModalComponent, AdminProfileComponent, AdminUniqueEmailDirective
    ], providers: [],
    exports: [AdminDetailsComponent, AdminFilterComponent, AdminModalComponent, AdminProfileComponent, AdminUniqueEmailDirective]
})
export class AdminModule { }
